module.exports = __webpack_public_path__ + "img/3B4235_7B9395_5B716C_70847B-256px.0ff8b506.png";